import React, { useState } from 'react';
import { FileText, Bot, Sparkles } from 'lucide-react';
import AIChat from '../components/dashboard/AIChat';
import { ApplicationTemplates } from '../components/dashboard/ApplicationTemplates';
import ApplicationBuilder from '../components/dashboard/ApplicationBuilder';

type DashboardTab = 'ai-chat' | 'templates' | 'builder';

const Dashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<DashboardTab>('ai-chat');

  const tabs = [
    { 
      id: 'ai-chat', 
      label: 'AI Assistent', 
      icon: <Bot className="w-5 h-5" />,
      description: 'Få personlig hjälp med din ansökan'
    },
    { 
      id: 'templates', 
      label: 'Mallar', 
      icon: <FileText className="w-5 h-5" />,
      description: 'Professionella ansökningsmallar'
    },
    { 
      id: 'builder', 
      label: 'Ansökningsbyggare', 
      icon: <Sparkles className="w-5 h-5" />,
      description: 'Skapa din ansökan steg för steg'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-rose-50 to-white">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Premium Dashboard
          </h1>
          <p className="text-gray-600">
            Använd våra premium-verktyg för att skapa professionella ansökningar
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 mb-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id as DashboardTab)}
              className={`p-4 rounded-xl text-left transition-all duration-200 ${
                activeTab === tab.id
                  ? 'bg-rose-600 text-white shadow-lg scale-[1.02]'
                  : 'bg-white text-gray-600 hover:bg-rose-50'
              }`}
            >
              <div className="flex items-center gap-3 mb-2">
                {tab.icon}
                <span className="font-semibold">{tab.label}</span>
              </div>
              <p className={`text-sm ${
                activeTab === tab.id ? 'text-rose-100' : 'text-gray-500'
              }`}>
                {tab.description}
              </p>
            </button>
          ))}
        </div>

        <div className="bg-white rounded-xl shadow-lg p-6">
          {activeTab === 'ai-chat' && <AIChat />}
          {activeTab === 'templates' && <ApplicationTemplates />}
          {activeTab === 'builder' && <ApplicationBuilder />}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;